import React, { useState } from "react";
import { login } from "./auth/msal";

const LoginScreen = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    // Credentials are not used; MSAL handles auth via redirect.
    await login();
  };

  // Inline CSS var sets optional background image; defaults to /bg-factory.jpg in public
  const bgUrl = process.env.REACT_APP_LOGIN_BG_URL || "/bg-factory.jpg";
  const logoUrl = process.env.REACT_APP_LOGIN_LOGO_URL || "/logo.png";
  const bgStyle = { "--login-bg": `url('${bgUrl}') center/cover no-repeat` };

  return (
    <div className="login-container">
      <div className="login-bg" aria-hidden="true" style={bgStyle} />
      <div className="login-overlay" aria-hidden="true" />
      <div className="login-center">
        <div className="login-card">
          {/* Optional brand logo; hidden if not found */}
          <img
            className="login-logo"
            src={logoUrl}
            alt="StratAlign Solutions logo"
            onError={(e) => { e.currentTarget.style.display = "none"; }}
          />
          <div className="login-title">StratAlign Solutions</div>
          <form className="login-form" onSubmit={onSubmit}>
            <label className="sr-only" htmlFor="login-username">Username</label>
            <input
              className="login-input"
              type="text"
              placeholder="Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              id="login-username"
              aria-label="Username"
              autoComplete="username"
            />
            <label className="sr-only" htmlFor="login-password">Password</label>
            <input
              className="login-input"
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              id="login-password"
              aria-label="Password"
              autoComplete="current-password"
            />
            <button className="login-btn" type="submit">LOGIN</button>
            <button
              className="login-btn"
              type="button"
              onClick={login}
            >
              Login with EntraID
            </button>
            <div className="login-note">Sign in with Microsoft Entra</div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
